var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMountain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "#0067FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8068 13.4019C17.7688 12.4219 14.4898 11.7979 11.5068 11.7979C9.67877 11.7979 8.55578 8.63494 8.24277 6.56295L9.42478 4.55595C9.68978 4.10597 10.0677 3.73297 10.521 3.47383C10.9744 3.21468 11.4876 3.07837 12.0098 3.07837C12.532 3.07837 13.0451 3.21468 13.4985 3.47383C13.9519 3.73297 14.3298 4.10597 14.5948 4.55595L19.8068 13.4019ZM21.4798 16.2409L21.6198 16.4769C21.8883 16.9327 22.0316 17.4513 22.035 17.9803C22.0385 18.5093 21.902 19.0298 21.6395 19.489C21.3769 19.9482 20.9976 20.3298 20.54 20.5952C20.0824 20.8605 19.5628 21.0002 19.0338 20.9999H4.98478C4.45588 21 3.93637 20.8602 3.4789 20.5948C3.02142 20.3294 2.64225 19.9477 2.37981 19.4885C2.11737 19.0294 1.981 18.5089 1.9845 17.9801C1.98801 17.4512 2.13127 16.9326 2.39978 16.4769L6.91678 8.81295C7.33378 11.5729 9.06077 13.7979 11.5068 13.7979C14.2538 13.7979 18.2168 14.3339 21.4798 16.2409Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMountain);
export default __webpack_public_path__ + "static/media/icon-mountain.61b643688282014d1f58c1fd0cf87791.svg";
export { ForwardRef as ReactComponent };